import React from 'react';
import { useGame } from '../context/GameContext';

const Leaderboard = () => {
    const { leaderboard, player } = useGame();

    return (
        <div id="status">
            <span className="title">Leaderboard</span>
            {leaderboard.map((entry, index) => (
                <React.Fragment key={index}>
                    <br />
                    {entry.id === player.id ? (
                        <span className="me">
                            {index + 1}. {entry.name.length > 0 ? entry.name : 'An unnamed cell'}
                        </span>
                    ) : (
                        <span>
                            {index + 1}. {entry.name.length > 0 ? entry.name : 'An unnamed cell'}
                        </span>
                    )}
                </React.Fragment>
            ))}
        </div>
    );
};

export default Leaderboard;


